import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Rating } from "react-simple-star-rating";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

import "./feedback.scss";
import Header from "../../components/header/header";
import Button from "../../components/button/button";
// import ImageUpload from "../../components/imageUpload/imageUpload";
import RatingIcon from "../../assets/rating.json";
import AlreadyExist from "../../assets/alreadyExist.json";
import ModalPopUp from "../../components/modal/modal";
import {pageUrl} from "../../utils/pageConstant";
import InsertReviewsAPI from "../../services/CreateReviews/CreateReviews";

const Feedback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const form = useForm();
  const { handleSubmit } = form;
  const walletReward = useSelector((state) => state.wallet.coins);

  const [active, setActive] = useState(null);
  const [impressionValue, setImpressionValue] = useState();
  const [ratingValue, setRatingValue] = useState(0);
  const [outLetID, setOutLetID] = useState();
  const [tranID, setTranID] = useState();
  // const [uploadImage, setUploadImage] = useState({ preview: "", raw: "" });
  const [statusIcon, setStatusIcon] = useState({});
  const [message, setMessage] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reviewComments, setReviewComments] = useState("");

  const impression = [
    { id: 1, name: "food" },
    { id: 2, name: "Ambience" },
    { id: 3, name: "Service" },
    { id: 4, name: "Washroom hygiene" },
  ];

  const tooltipArray = [
    "Terrible",
    "Terrible+",
    "Bad",
    "Bad+",
    "Average",
    "Average+",
    "Great",
    "Great+",
    "Awesome",
    "Awesome+"
  ];

  useEffect(() => {
    const outletID = location?.state?.outletID;
    const transactionID = location?.state?.paymentDetails?.localCouponDetails[0]?.tranasctionId || location?.state?.paymentDetails?.localCouponDetails[0]?.transactionId||"";
    setOutLetID(outletID);
    setTranID(transactionID);
    setActive(impression[0].id);
    setImpressionValue(impression[0].name);
  }, []);

  const handleBack = () => { 
    navigate(pageUrl.PROFILE);
  };

  const handleFeedbackRating = (rating) => {
    setRatingValue(rating);
  };

  const handleFeedbackSubmit = async () => {
    try {
      const resposneData = await InsertReviewsAPI(
        outLetID,
        impressionValue,
        ratingValue,
        reviewComments,
        tranID
      );
      if (resposneData?.statusCode === 200 && resposneData?.status === 1) {
        setIsModalOpen(true);
        setStatusIcon({ icon: RatingIcon });
        setMessage({
          title: "Feedback!",
          text: resposneData?.message,
        });
      } else if(resposneData?.statusCode === 200 && resposneData?.status === 2) {
        setIsModalOpen(true);
        setStatusIcon({ icon: AlreadyExist });
        setMessage({
          title: "Feedback!",
          text: resposneData?.message,
        });
      } else {
        setIsModalOpen(true);
        setStatusIcon({ icon: AlreadyExist });
        setMessage({
          title: "Feedback!",
          text: "Unable to add review",
        });
      }
    } catch (error) {
      console.log("reviews---", error);
      setIsModalOpen(true);
      setStatusIcon({ icon: AlreadyExist });
      setMessage({
        title: "Oops!",
        text: "Unexpected issue, try again.",
      });
    }
    // navigate("/profile");
  };

  const handleImpression = (impression) => {
    setActive(impression.id);
    setImpressionValue(impression.name);
  };

  // const handleUploadImage = (e) => {
  //   if (e.target.files.length) {
  //     const formData = new FormData();
  //     formData.append("Image1", e.target.files[0]);
  //     console.log("eeeee", e.target.files);
  //     setUploadImage({
  //       preview: URL.createObjectURL(e.target.files[0]),
  //       raw: e.target.files[0],
  //     });
  //   }
  // };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    navigate("/outlet-list")
  };

  const hnadleDescChange = (e) => {
    setReviewComments(e.target.value);
  };

  return (
    <div className="feedback-page">
      <Header coin={walletReward} onClick={handleBack} label="Rate Us" />
      <div className="mainContent">
        <div className="title">Thanks for rating!</div>
        <div className="rating-section">
          <Rating style={{display: "flex", flexDirection: "column"}}
            allowFraction
            onClick={handleFeedbackRating}
            // showTooltip
            // allowHover
            tooltipArray={tooltipArray}
            // transition
          />
        </div>
        <div className="sub-title">What impressed you ?</div>
      </div>
      <div className="impression-content">
        {impression.map((imp) => (
          <div
            key={imp.id}
            className={`impression-style ${
              imp.id === active ? "activeEl" : ""
            }`}
            onClick={() => handleImpression(imp)}
          >
            {imp.name}
          </div>
        ))}
      </div>
      <div className="detail-title">Add detailed review</div>
      <form
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit(handleFeedbackSubmit)}
      >
        <FormControl sx={{ width: "100%" }}>
          <TextField
            id="outlined-multiline-static"
            className="query-desc"
            multiline
            rows={4}
            placeholder="Write here"
            onChange={hnadleDescChange}
          />
          {/* <ImageUpload onChange={handleUploadImage} uploadImage={uploadImage} /> */}
          <div className="btn-section">
            <Button btnText="Submit" btnStyle="button-style" />
          </div>
          {isModalOpen && (
            <ModalPopUp
              isOpen={isModalOpen}
              handleModalClose={handleCloseModal}
              message={message}
              icon={statusIcon.icon}
            />
          )}
        </FormControl>
      </form>
    </div>
  );
};

export default Feedback;
